import { render, staticRenderFns } from "./DeactivationReviewModal.vue?vue&type=template&id=14217eb0&scoped=true&"
import script from "./DeactivationReviewModal.vue?vue&type=script&lang=ts&"
export * from "./DeactivationReviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivationReviewModal.vue?vue&type=style&index=0&id=14217eb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14217eb0",
  null
  
)

export default component.exports